import { SearchResultsModel } from '@/services/GeneratedApi';
import { RootState, SearchCriteriaModel, StoreConstants, TableFilterModel, TableSortModel } from '@/types';
import { SearchState } from '@/types/store/search';
import { ActionTree } from 'vuex';

export const actions: ActionTree<SearchState, RootState> = {
  [StoreConstants.Search.Actions.SetSearchCriteria](this: any, { commit, dispatch, rootState }, searchCriteria: SearchCriteriaModel) {
    const root: any = rootState;
    const userId = root.oidcStore.user.id;
    commit(StoreConstants.Search.Mutations.SetSearchCriteria, { ...searchCriteria, userId });
    dispatch(
      `${StoreConstants.UserPreferences.ModuleName}/${StoreConstants.UserPreferences.Actions.SetSearchOptions}`,
      {
        cabinets: searchCriteria.cabinets,
        documentTypes: searchCriteria.documentTypes
      },
      { root: true }
    );
  },
  [StoreConstants.Search.Actions.SetSelectedItems]({ commit }, keys: string[]) {
    commit(StoreConstants.Search.Mutations.SetSelectedItems, keys);
  },
  [StoreConstants.Search.Actions.SetCurrentPage]({ commit }, page: number) {
    commit(StoreConstants.Search.Mutations.SetCurrentPage, page);
  },
  [StoreConstants.Search.Actions.SetItemsPerPage]({ commit }, count: number) {
    commit(StoreConstants.Search.Mutations.SetItemsPerPage, count);
  },
  [StoreConstants.Search.Actions.SetShowSorting]({ commit }, show: boolean) {
    commit(StoreConstants.Search.Mutations.SetShowSorting, show);
  },
  [StoreConstants.Search.Actions.SetShowFilters]({ commit }, show: boolean) {
    commit(StoreConstants.Search.Mutations.SetShowFilters, show);
  },
  [StoreConstants.Search.Actions.SetAppliedFilterOptions]({ commit }, options: TableFilterModel[]) {
    commit(StoreConstants.Search.Mutations.SetAppliedFilterOptions, options);
  },
  [StoreConstants.Search.Actions.SetAppliedSortOptions]({ commit }, options: TableSortModel[]) {
    commit(StoreConstants.Search.Mutations.SetAppliedSortOptions, options);
  },
  [StoreConstants.Search.Actions.SetColumnOrders]({ commit }, orders: string[]) {
    commit(StoreConstants.Search.Mutations.SetColumnOrders, orders);
  },
  [StoreConstants.Search.Actions.SetSplitConfiguration]({ commit }, config: number) {
    commit(StoreConstants.Search.Mutations.SetSplitConfiguration, config);
  },
  [StoreConstants.Search.Actions.SetSearchResponse]({ commit }, response: SearchResultsModel) {
    commit(StoreConstants.Search.Mutations.SetSearchResponse, response);
  },
  [StoreConstants.Search.Actions.SetUnsortedItems]({ commit }, unsortedItems: any[]) {
    commit(StoreConstants.Search.Mutations.SetUnsortedItems, unsortedItems);
  },
  [StoreConstants.Search.Actions.SetLastViewedDocument]({ commit }, { cabinetId, documentId }) {
    commit(StoreConstants.Search.Mutations.SetLastViewedDocument, { cabinetId, documentId });
  },
  [StoreConstants.Search.Actions.UnloadSearchResults]({ commit }) {
    commit(StoreConstants.Search.Mutations.UnloadSearchResults);
  },
  [StoreConstants.Search.Actions.ResetSearchResults]({ commit }) {
    commit(StoreConstants.Search.Mutations.ResetSearchResults);
  }
};
